<template>
  <section class="home">
      <div class="areaselect">地区选择</div>
    <van-grid :column-num="1">
      <van-grid-item
        v-for="item in list"
        @click="OnDetailClick(item.AreaID)"
        :key="item.AreaID"
        :text="item.AreaName"
      /></van-grid>
    </van-grid>
  </section>
</template>
<script>
import { BzAjax, BzJs, BzUser, BzMsg } from "@/modules/js/helper";
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false
    };
  },
  created() {
    this.getlist();
  },
  methods: {
    OnDetailClick(AreaID) {
        this.$router.push("/areatotle/" + AreaID);
    },
    getlist: function() {
      BzAjax.post("/WSD/Area/GetUserArea").then(d => {
        this.list = d.Areas;
        this.StoreID = d.StoreID;
        this.StoreName = d.StoreName;
        if (d.StoreID != 0) {
          //   this.$store.commit("setState", {
          //     StoreID: d.StoreID,
          //     StoreName: d.StoreName,
          //     selectArea: 0
          //   });
          //   this.$router.push({
          //     name: "rightls",
          //     params: {
          //       StoreID: d.StoreID,
          //       ClientType: 0,
          //       StoreType: 0,
          //       AreaID: 0,
          //       Status: 1
          //     }
          //   });
        } else {
          //   this.selectArea = d.Areas[0].AreaID;
          //   this.$store.commit("setState", {
          //     StoreID: 0,
          //     StoreName: "",
          //     selectArea: this.selectArea
          //   });
          //   this.$router.push(
          //     "/default/" + d.Areas[0].AreaID + "/" + d.Areas[0].AreaName
          //   );
        }
      });
    }
  }
};
</script>
<style lang="less">
.home{
    .areaselect{
        width: 100%;
      text-align: center;
         font-size: 1.2rem;
         font-weight: 1000;
         margin-top: 1.2rem;
        height: 2.4rem;
    }
    .van-grid-item__text{
    font-size: 1.2rem;
    }
}

</style>


// WEBPACK FOOTER //
// src/pages/home/home.vue